import config from "@/libs/config";
import React from "react";
import { Button, Modal, Font } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";
import { BizsolDisconnectStepper } from "@/components/atoms/BizsolDisconnectStepper";
import { color } from "@/styles/theme";
import {
  TemporaryPasswordLabel,
  UrlLabel,
  UsernameLabel,
} from "@/components/molecules";
import { useRecoilState } from "recoil";
import { bizsolDisconnectModalState } from "@/store/bizsolDisconnectModalState";

type Props = {
  title: string;
  username: string;
  onClickCancel: () => void;
};

export const BizsolDisconnectModalContentStep3 = ({
  title,
  username,
  onClickCancel,
}: Props) => {
  const [disconnectState] = useRecoilState(bizsolDisconnectModalState);

  const body = (
    <div>
      <BizsolDisconnectStepper step={3} />
      <Font variant="l" component="p">
        再連携の準備が出来ました。
        <br />
        該当者に以下をお伝えし、Mikatano IDで7日以内にログインしてください。
      </Font>
      <div css={inputWrapper}>
        <UsernameLabel username={username} label={"Mikatano ID"} />
        <TemporaryPasswordLabel
          temporaryPassword={disconnectState.temporaryPassword}
        />
        <UrlLabel url={config.XID_URL} />
      </div>
    </div>
  );

  const footerButtons = (
    <>
      <Button type="button" variant="primary" onClick={onClickCancel}>
        閉じる
      </Button>
    </>
  );

  return (
    <Modal
      css={modal}
      title={title}
      body={body}
      zIndex={5}
      footerButtons={footerButtons}
      onClose={onClickCancel}
      backgroundColor={color.backgroundGray}
    />
  );
};

const modal = css({
  width: "614px",
});

const inputWrapper = css({
  marginTop: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});
